import { render, staticRenderFns } from "./DonatorContacHisComp.vue?vue&type=template&id=d4c25a2c"
import script from "./DonatorContacHisComp.vue?vue&type=script&lang=js"
export * from "./DonatorContacHisComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports